<template>
    <v-card>
        <v-card-title class="primary white--text">
            <v-btn icon @click="cancelDialog()"><v-icon class="white--text">close</v-icon></v-btn>
            <div class="title">{{ $t('Nouvelle connaissance') }}</div>
            <v-spacer></v-spacer>
            <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="submitDialogCreateIntention()" class="white--text">{{ $t('submit') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            style="display: none;"
            autofocus
            required
            :label="$t('faqCode')" 
            v-model="newFaqDialog.intend"
            counter 
            max="32" 
            v-validate="'max:32'"
            data-vv-name="codeFAQ"
          >
          </v-text-field>
          <v-text-field
            v-model="newFaqDialog.name"
            box
            color="primary"
            :label="$t('* Sujet')"
          ></v-text-field>
          <v-textarea 
            :label="$t('* Description')" 
            v-model="newFaqDialog.desc"
            required
            color="primary"
            counter
            maxlength="128"
          ></v-textarea>
          <v-textarea 
            v-if="newIntentExemple.ex"
            :label="$t('* Exemple de message de l\'internaute')" 
            v-model="newIntentExemple.ex"
            required
            color="primary"
          ></v-textarea>
          <v-textarea 
            v-else
            :label="$t('* Exemple de message de l\'internaute')" 
            v-model="newFaqDialog.response"
            required
            color="primary"
          ></v-textarea>
          <small>*{{ $t('required') }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="cancelDialog()">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" flat @click.native="submitDialogCreateIntention()">{{ $t('submit') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    newIntentExemple: {
      type: Object,
      default: () => ({})
    },
    modeExpert: {
      type: Boolean,
      default: false
    },
    botWorkspace: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      newFaqDialog: {intend: '', name: '', desc: '', response: ''},
      loading: false
    }
  },
  mounted () {},
  updated () {},
  computed: {},
  methods: {
    cancelDialog () {
      this.$emit('closeDialog')
      // si pas debase de connaissance reconnu pour ce bot
      // if (!this.$store.state._Sites.baseConnaissanceID || this.$store.state._Sites.baseConnaissanceID === '') {
      //   console.log('pas encore de folder base de connaissance')
      //   // il faut tester si il existe une base de connaissance pour ce bot
      //   this.listeAllDialogNodes()
      // } else {
      //   // et maintenant création de la nouvelle connaissance
      //   console.log('il y a bien un folder base de connaissance')
      //   // this.creatNewNodeConnaissance(data)
      // }
    },
    submitNewFAQ () {
      this.$emit('addNewFAQ', this.newFaqDialog)
    },
    // création de la nouvelle intention
    submitDialogCreateIntention () {
      this.newFaqDialog.intend = 'tf_' + Date.now()
      // console.log('value', this.newFaqDialog)
      if (this.newIntentExemple.ex) {
        this.newFaqDialog.response = this.newIntentExemple.ex
      }
      if (this.newFaqDialog.response !== '' && this.newFaqDialog.desc !== '' && this.newFaqDialog.name !== '') {
        // Données modifiées et à renvoyer
        let dataToPost = new window.FormData()
        dataToPost.append('code', this.newFaqDialog.intend)
        dataToPost.append('desc', this.newFaqDialog.desc)
        dataToPost.append('name', this.newFaqDialog.name)
        dataToPost.append('ex', this.newFaqDialog.response !== '' ? this.newFaqDialog.response : '')
        dataToPost.append('is_faq', '1')
        dataToPost.append('botWorkspace', this.botWorkspace)
        this.axios.post('https://public.targetfirst.com/public/ibm/new_intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        // this.axios.post('put/intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          let dataIntention = {
            code: this.newFaqDialog.intend,
            name: this.newFaqDialog.name,
            desc: this.newFaqDialog.desc,
            ex: [this.newFaqDialog.response]
          }
          this.addNewIntention(dataIntention) // ajoute dans la liste la nouvelle intention
          this.$emit('closeDialog')
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('erreur intention'), context: 'error' })
        })
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('Veuillez remplir les champs obligatoires.'), context: 'error' })
      }
    },
    // ajoute la nouvelle intention dans la liste des intentions
    addNewIntention (data) {
      // console.log('addNewIntention', data)
      // si pas de base de connaissance reconnu pour ce bot
      if (!this.$store.state._Sites.baseConnaissanceID || this.$store.state._Sites.baseConnaissanceID === '') {
        // console.log('pas encore de folder base de connaissance')
        // il faut tester si il existe une base de connaissance pour ce bot
        this.listeAllDialogNodes(data)
      } else {
        // et maintenant création de la nouvelle connaissance
        // console.log('il y a bien un folder base de connaissance')
        this.creatNewNodeConnaissance(data)
      }
    },
    // liste tout les dialogNodes
    listeAllDialogNodes (newIntention) {
      // console.log('listeAllDialogNodes')
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('botWorkspace', this.botWorkspace)
      this.axios.post('https://public.targetfirst.com/public/ibm/get-list-dialogNodes.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      // this.axios.post('put/intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        // console.log('response', response.data.dialog_nodes)
        // console.log('response dialogNodes', response.data.dialog_nodes)
        this.checkBaseConnaissance(newIntention, response.data.dialog_nodes)
      })
      .catch(_ => {
        // console.log('erreur response', response)
        // this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('erreur node'), context: 'error' })
      })
    },
    // check l'existance d'une base de connaissance
    checkBaseConnaissance (newIntention, listeAllDialogNodes) {
      // console.log('checkBaseConnaissance listeDialogNodes', listeAllDialogNodes)
      let baseFind = 0
      let idFind = ''
      listeAllDialogNodes.forEach(function (node) {
        if (node.type === 'folder' || node.type === 'faq') {
          if (node.title.indexOf('Base de connaissances') !== -1) {
            // console.log('il y a bien un folder base de connaissance dispo', node.dialog_node)
            idFind = node.dialog_node
            // this.baseConnaissanceID = node.dialog_node
            // this.$store.commit('_Sites/SET_BASE_CONNAISSANCE', 10)
            // this.creatNewNodeConnaissance (newIntention)
            // console.log('new intention', newIntention)
            baseFind++
          }
        }
      })
      if (!baseFind) {
        // console.log('pas trouvé de base de connaissance')
        this.addDialogNodesBaseConnaissance(newIntention)
      } else {
        // console.log('trouvé une base de connaissance')
        this.$store.commit('_Sites/SET_BASE_CONNAISSANCE', idFind)
        this.creatNewNodeConnaissance(newIntention)
      }
    },
    // création d'un dialogNodes 'base de connaissance'
    addDialogNodesBaseConnaissance (newIntention) {
      // console.log('addDialogNodesBaseConnaissance')
      let newDialogNode = 'tf_' + Date.now()
      this.$store.commit('_Sites/SET_BASE_CONNAISSANCE', newDialogNode)
      let dataToPost = new window.FormData()
      dataToPost.append('dialog_node', newDialogNode)
      dataToPost.append('desk', 'Répertoire de stockage des toutes les questions/réponses')
      dataToPost.append('type', 'folder')
      dataToPost.append('botWorkspace', this.botWorkspace)
      this.axios.post('https://public.targetfirst.com/public/ibm/create_base_connaissances.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        // console.log('creation ok response', response)
        this.creatNewNodeConnaissance(newIntention)
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creation de la base de connaissances'), context: 'success' })
      })
      .catch(_ => {
        // console.log('erreur response', response)
        this.$store.commit('_Sites/SET_BASE_CONNAISSANCE', '')
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('erreur node'), context: 'error' })
      })
    },
    // création de la nouvelle connaissance
    creatNewNodeConnaissance (newIntention) {
      // console.log('creation nouvelle base de connaissances response', newIntention)
      // console.log('this.$store.state._Sites.baseConnaissanceID', this.$store.state._Sites.baseConnaissanceID)
      let responseBot = JSON.stringify({generic: [{values: [{text: ''}], response_type: 'text', selection_policy: 'sequential'}, {time: 2000, typing: true, response_type: 'pause'}]})
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('name', newIntention.name)
      dataToPost.append('desk', newIntention.desc)
      dataToPost.append('response', responseBot)
      dataToPost.append('parent', this.$store.state._Sites.baseConnaissanceID) // le node de la base de connaissance
      dataToPost.append('conditions', '#' + newIntention.code)
      dataToPost.append('botWorkspace', this.botWorkspace)
      this.axios.post('https://public.targetfirst.com/public/ibm/new_node_base_connaissances.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      // this.axios.post('put/intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        // console.log('creation ok response', response)
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('Création de la nouvelle connaissance'), context: 'success' })
        // this.$emit('newIntendOK', this.newIntentDialog)
        this.addNewFaq(response.data)
        // this.cancelDialogEdit()
        // this.creatNewNodeConnaissance(response.data)
        // mise à jour des la liste des intention du store
        let listIntents = _.cloneDeep(this.$store.state._Sites.intents)
        listIntents.push({
          name: newIntention.name,
          value: newIntention.code,
          code: newIntention.code,
          desc: newIntention.desc,
          ex: newIntention.ex,
          botWorkspace: this.botWorkspace
        })
        this.$store.commit('_Sites/SET_INTENTS', listIntents)
      })
      .catch(_ => {
        // console.log('erreur response', response)
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('erreur de création'), context: 'error' })
      })
    },
    // ajout la nouvelle faq
    addNewFaq (data) {
      console.log('addNewfaq data', data)
      let newIntention = {
        dialogNode: data.dialog_node,
        id: data.nodeID,
        intend: data.conditions,
        desc: data.desk,
        name: data.name,
        parent: data.parent,
        type: data.type,
        response: '',
        output1: {},
        output2: {}
      }
      // efface les anciennes infos
      this.newFaqDialog = {intend: '', name: '', desc: '', response: ''}
      // this.faqs.push(newIntention)
      // this.classementFAQ()
      // console.log('this.faqs', this.faqs)
      // ferme la dialogbox creation intention
      // this.showDialogCreate = false
      // ouvre la dialogbox modification base de connaissance avec la nouvelle intention
      // this.openDialogUpdate(newIntention)
      this.$emit('updateFAQ', newIntention)
    }
  },
  watch: {},
  filters: {}
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzNewFAQ.vue